"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeExists = exports.OutOfSyncError = void 0;
class OutOfSyncError extends Error {
    constructor(message) {
        super(message);
        this.name = "OutOfSyncError";
    }
}
exports.OutOfSyncError = OutOfSyncError;
/**
 * An invariant asserting that a node exists as expected.
 * A failed assertion will throw an {@link OutOfSyncError}.
 * */
function nodeExists(node, errorMessage) {
    if (node)
        return;
    throw new OutOfSyncError(errorMessage);
}
exports.nodeExists = nodeExists;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL0JlZHJvY2tGUy9lcnJvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBYSxjQUFlLFNBQVEsS0FBSztJQUN2QyxZQUFZLE9BQWU7UUFDekIsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ2YsSUFBSSxDQUFDLElBQUksR0FBRyxnQkFBZ0IsQ0FBQztJQUMvQixDQUFDO0NBQ0Y7QUFMRCx3Q0FLQztBQUVEOzs7S0FHSztBQUNMLFNBQWdCLFVBQVUsQ0FDeEIsSUFBMEIsRUFDMUIsWUFBb0I7SUFFcEIsSUFBSSxJQUFJO1FBQUUsT0FBTztJQUNqQixNQUFNLElBQUksY0FBYyxDQUFDLFlBQVksQ0FBQyxDQUFDO0FBQ3pDLENBQUM7QUFORCxnQ0FNQyJ9